import { useState } from "react";
import { Header, Icon, Segment } from "semantic-ui-react";
import LayoutWithSidebar from "../components/LayoutWithSidebar";
import MainSideMenu from "../components/MainSideMenu";
import LicencesDashboardContainer from "../containers/LicencesDashboardContainer";
import LicencesListContainer from "../containers/LicencesListContainer";
import MainHeaderContainer from "../containers/MainHeaderContainer";

const LicencePage = () => {
  const [isDashboardOpen, setIsDashboardOpen] = useState(true);

  const headerContent = () => {
    return <MainHeaderContainer></MainHeaderContainer>;
  };

  const sidebarContent = () => {
    return <MainSideMenu></MainSideMenu>;
  };

  const contentPanelContent = () => {
    return (
      <>
        <Segment basic>
          <Header as="h2">Licences</Header>
        </Segment>
        {isDashboardOpen && <LicencesDashboardContainer />}
        <div
          style={{
            borderBottom: "1px solid rgba(34, 36, 38, 0.15)",
            textAlign: "center",
            margin: "0 0 1rem",
            position: "relative",
          }}
        >
          <Icon
            name={isDashboardOpen ? "angle up" : "angle down"}
            circular
            link
            onClick={() => setIsDashboardOpen((prev) => !prev)}
            style={{
              background: "white",
              position: "relative",
              top: "1rem",
            }}
          />
        </div>
        <LicencesListContainer></LicencesListContainer>
      </>
    );
  };

  return (
    <LayoutWithSidebar
      headerContent={headerContent()}
      sidebarContent={sidebarContent()}
      mainPanelContent={contentPanelContent()}
    ></LayoutWithSidebar>
  );
};

export default LicencePage;
